export enum AlertStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
  UNCONFIGURED = 'UNCONFIGURED',
}

export enum FundListSortColumn {
  TICKER,
  FUND_NAME,
  ACTIVITY,
  LARGEST_TRADE,
}

export enum SortDirection {
  ASCENDING,
  DESCENDING,
}

/**
 * Sort is applied client-side; the date and tenant go to the server and pick
 * which day's activity comes back.
 */
export interface CustomerActivityListSortAndFilter {
  sortColumn: FundListSortColumn;
  sortDirection: SortDirection;
  tradeDateAsYyyyMmDd?: string;
  tenant?: string;
}
